var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-row', {
    attrs: {
      "align": "end"
    }
  }, [_c('v-col', [_c('h5', {
    staticClass: "page-text--lg"
  }, [_vm._v("문자발송")])]), _vm._v(" "), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('texting-form-point')], 1)], 1), _c('vertical-form-table', _vm._b({
    staticClass: "mt-8 mt-lg-16",
    scopedSlots: _vm._u([_vm.recruitment ? {
      key: "회사명",
      fn: function fn() {
        var _vm$recruitment, _vm$recruitment$compa;
        return [_vm._v(" " + _vm._s(((_vm$recruitment = _vm.recruitment) === null || _vm$recruitment === void 0 ? void 0 : (_vm$recruitment$compa = _vm$recruitment.company) === null || _vm$recruitment$compa === void 0 ? void 0 : _vm$recruitment$compa.name) || "-") + " ")];
      },
      proxy: true
    } : {
      key: "회사명",
      fn: function fn() {
        return [_c('v-text-field', _vm._b({
          attrs: {
            "auto-grow": "",
            "placeholder": "회사명을 적어주세요."
          },
          model: {
            value: _vm.form.addresser.company,
            callback: function callback($$v) {
              _vm.$set(_vm.form.addresser, "company", $$v);
            },
            expression: "form.addresser.company"
          }
        }, 'v-text-field', _vm.attrs_input, false))];
      },
      proxy: true
    }, {
      key: "담당자명",
      fn: function fn() {
        return [_c('v-text-field', _vm._b({
          attrs: {
            "auto-grow": "",
            "placeholder": "담당자명을 적어주세요."
          },
          model: {
            value: _vm.form.addresser.name,
            callback: function callback($$v) {
              _vm.$set(_vm.form.addresser, "name", $$v);
            },
            expression: "form.addresser.name"
          }
        }, 'v-text-field', _vm.attrs_input, false))];
      },
      proxy: true
    }, {
      key: "연락처",
      fn: function fn() {
        return [_c('v-text-field', _vm._b({
          attrs: {
            "auto-grow": "",
            "placeholder": "연락처를 적어주세요."
          },
          model: {
            value: _vm.form.addresser.phone,
            callback: function callback($$v) {
              _vm.$set(_vm.form.addresser, "phone", $$v);
            },
            expression: "form.addresser.phone"
          }
        }, 'v-text-field', _vm.attrs_input, false))];
      },
      proxy: true
    }, {
      key: "발송번호",
      fn: function fn() {
        return [_c('texting-form-addressees', _vm._b({
          attrs: {
            "items": _vm.addresseeItems,
            "readonly": _vm.readonlyAddressees
          },
          model: {
            value: _vm.form.addressees,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "addressees", $$v);
            },
            expression: "form.addressees"
          }
        }, 'texting-form-addressees', _vm.attrs_input, false))];
      },
      proxy: true
    }, {
      key: "문자내용",
      fn: function fn() {
        return [_c('v-textarea', _vm._b({
          attrs: {
            "auto-grow": ""
          },
          model: {
            value: _vm.form.message,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "message", $$v);
            },
            expression: "form.message"
          }
        }, 'v-textarea', _vm.attrs_input, false))];
      },
      proxy: true
    }, {
      key: "미리보기",
      fn: function fn() {
        return [_c('v-textarea', _vm._b({
          staticClass: "preview-textarea mb-n8",
          attrs: {
            "value": _vm.preview,
            "readonly": "",
            "auto-grow": "",
            "rows": "1",
            "hide-details": false,
            "counter": "",
            "counterValue": _vm.counterValue
          }
        }, 'v-textarea', _vm.attrs_input, false))];
      },
      proxy: true
    }, {
      key: "차감포인트",
      fn: function fn() {
        var _vm$previewPointTotal, _vm$previewPointTotal2, _vm$previewPointPerIt, _vm$previewPointPerIt2;
        return [_vm._v(" " + _vm._s(((_vm$previewPointTotal = _vm.previewPointTotal) === null || _vm$previewPointTotal === void 0 ? void 0 : (_vm$previewPointTotal2 = _vm$previewPointTotal.format) === null || _vm$previewPointTotal2 === void 0 ? void 0 : _vm$previewPointTotal2.call(_vm$previewPointTotal)) || 0) + "원 (건당 " + _vm._s((_vm$previewPointPerIt = _vm.previewPointPerItem) === null || _vm$previewPointPerIt === void 0 ? void 0 : (_vm$previewPointPerIt2 = _vm$previewPointPerIt.format) === null || _vm$previewPointPerIt2 === void 0 ? void 0 : _vm$previewPointPerIt2.call(_vm$previewPointPerIt)) + "원) ")];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'vertical-form-table', {
    items: _vm.items
  }, false)), _c('v-layout', {
    staticClass: "mt-20 mt-lg-40",
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-btn', _vm._b({
    staticClass: "min-w-100px min-w-lg-140px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.post
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v("문자발송")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }